module.exports = __webpack_public_path__ + "img/72.9e1c0979.png";